import React from 'react';

import { Text, Flex, xcss } from '@atlaskit/primitives';

import { fg } from '@confluence/feature-gating';

const optionStyles = xcss({
	paddingTop: 'space.050',
	paddingBottom: 'space.050',
	flexDirection: 'column',
});

type OptionWithWithDescriptionProps = {
	label: string;
	description: string;
	isSelected: boolean;
	isMenu: boolean;
};

export const OptionWithDescription = ({
	label,
	description,
	isSelected,
	isMenu,
}: OptionWithWithDescriptionProps): JSX.Element => (
	<Flex xcss={optionStyles}>
		<Text weight={!isMenu && fg('confluence_rbac_spaces_beta_opt_in') ? 'bold' : 'regular'}>
			{label}
		</Text>
		<Text color={isSelected ? 'color.text.subtle' : 'color.text.subtlest'} size="small">
			{description}
		</Text>
	</Flex>
);
